<form *ngIf='form() as form' [formGroup]='form' autocomplete='off' novalidate>
  <div class="row">
    <div class="col-12">
      <fieldset>
        <legend>
          {{ label }}
        </legend>
        <br>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"startDate" as controlName'>
              <label [for]='controlName'>
                Data od *
              </label>
              <app-date-picker (change)="form.startDateChange($event)" [id]='controlName'
                               [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"endDate" as controlName'>
              <label [for]='controlName'>
                Data do *
              </label>
              <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-4">
            <div class='form-group' *ngIf='"dayQuantity" as controlName'>
              <label [for]='controlName'>
                Ilość dni
              </label>
              <input
                readonly
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu ilość dni'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <br>
        <app-alert alertTitle="Uwaga!" [closable]="false">
          <p>Aby powierzchnie zostały wyliczone automatycznie na podstawie narysowanego obszaru:</p>
          <ol class="ms-4 mt-2">
            <li class="mb-2">
              Przejdź do funkcji <strong>GEOMETRIA</strong>
            </li>
            <li class="mb-2">
              Wybierz warstwę <strong>WIELOBOK</strong> i narysuj obszar na mapie.
            </li>
            <li class="mb-2">
              Wyślij geometrię.
            </li>
          </ol>
          <p>Po wysłaniu, w tabeli na końcu wniosku zostaną uzupełnione powierzchnie
            łączne. Sprawdź dane i w razie potrzeby popraw je ręcznie.</p>
        </app-alert>
        <app-exposed-map-control
          #expMap
          (dictionary)="form.onLoadExposedMapDict($event)"
          [applicationId]="applicationId()"
          [serviceId]="serviceId()"
          [control]="form.geometry">
        </app-exposed-map-control>
        <app-road-controls-set [expMapDict]="expMap.dictEvent()" [form]="form"></app-road-controls-set>
        <fieldset>
          <legend>
            Działki
          </legend>
          <div class="row">
            <div class="col-12">
              <app-parcels-crud [expMapDict]="expMap.dictEvent()" formControlName="parcels"></app-parcels-crud>
            </div>
          </div>
        </fieldset>
        <br>
        <div class="row">
          <div class="col-12">
            <app-alert alertTitle="Uwaga!" type="info" [closable]="false">
              Wypełnij min <strong>1</strong> z poniższych sekcji.
            </app-alert>
          </div>
        </div>
        <div formArrayName="purposeFees">
          @for (feeForm of form.purposeFeesForms; track $index) {
            <fieldset>
              <legend>
                {{ feeForm.name.value }}
              </legend>
              <div class='row' [formGroup]="feeForm">
                <div class='col-md-3'>
                  <div class='form-group' *ngIf='"width" as controlName'>
                    <label [for]='controlName'>
                      Szerokość (m)
                    </label>
                    <input
                      (change)='feeForm.calcArea()'
                      mask='separator.2'
                      decimalMarker=','
                      [dropSpecialCharacters]='false'
                      [id]='controlName'
                      [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                      [formControlName]='controlName'
                      placeholder='Wpisz tu szerokość'
                      type='text'>
                    <app-validation-errors [control]='feeForm.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class='col-md-3'>
                  <div class='form-group' *ngIf='"length" as controlName'>
                    <label [for]='controlName'>
                      Długość (m)
                    </label>
                    <input
                      (change)='feeForm.calcArea()'
                      mask='separator.2'
                      decimalMarker=','
                      [dropSpecialCharacters]='false'
                      [id]='controlName'
                      [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                      [formControlName]='controlName'
                      placeholder='Wpisz tu długość'
                      type='text'>
                    <app-validation-errors [control]='feeForm.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class='col-md-3'>
                  <div class='form-group' *ngIf='"area" as controlName'>
                    <label [for]='controlName'>
                      Powierzchnia (m<sup>2</sup>)
                    </label>
                    <input
                      mask='separator.2'
                      decimalMarker=','
                      [dropSpecialCharacters]='false'
                      [id]='controlName'
                      [ngClass]='{ "is-invalid": feeForm.showError(controlName) }'
                      [formControlName]='controlName'
                      placeholder='Powierzchnia'
                      type='text'>
                    <app-validation-errors [control]='feeForm.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class="col-md-3 d-flex align-items-center">
                  <button
                    aria-controls="roadWidth2 roadLength2 roadArea2"
                    [disabled]="!feeForm.canClearControls()"
                    (click)="feeForm.clearControls()"
                    title="Wyczyść wiersz"
                    class="btn btn-tertiary mb-4 mb-md-0"
                    type="button">
                    <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
                  </button>
                </div>
              </div>
            </fieldset>
          }
        </div>
      </fieldset>
    </div>
  </div>
</form>
